import { teamApi } from './client.ts'
import type {
  CreateTeamBody,
  GetTeamsByUserIdParams,
  PatchTeamMemberParams,
  GetTeamParams,
  GetTeamMembersMetadataParams,
  InviteTeamMemberParams,
  RemoveTeamMemberParams,
  ResendInviteParams,
  GetTeamPlanParams,
} from './params.ts'
import type { Team } from '@rundown-studio/types'
import { apiErrorHandler } from '../../../utils/api-error-handler'

export const createTeam = (body: CreateTeamBody) => {
  return apiErrorHandler(teamApi.post<Team>('/', body))
}

export const getTeamsByUserId = ({ userId }: GetTeamsByUserIdParams) => {
  return apiErrorHandler(teamApi.get<Team[]>(`/teams-by-uid/${userId}`))
}

export const patchTeamMember = ({
  teamId,
  uidOrEmail,
  payload,
}: PatchTeamMemberParams) => {
  return apiErrorHandler(
    teamApi.patch(`/${teamId}/members/${uidOrEmail}`, payload),
  )
}

export const getTeam = async ({ teamId }: GetTeamParams, { toast }: { toast?: boolean } = {}) => {
  return apiErrorHandler(teamApi.get(`/${teamId}`), { toast: toast ?? true })
}

export const getTeamMembersMetadata = async ({
  teamId,
}: GetTeamMembersMetadataParams) => {
  return apiErrorHandler(teamApi.get(`/${teamId}/members/meta`))
}

export const inviteTeamMember = async ({
  teamId,
  payload,
}: InviteTeamMemberParams) => {
  return await apiErrorHandler(teamApi.post(`/${teamId}/members`, payload))
}

export const removeTeamMember = async ({
  teamId,
  uidOrEmail,
}: RemoveTeamMemberParams) => {
  return apiErrorHandler(
    teamApi.delete<Team>(`/${teamId}/members/${uidOrEmail}`),
  )
}

export const resendInvite = async ({ teamId, payload }: ResendInviteParams) => {
  return await apiErrorHandler(
    teamApi.post<string>(`/${teamId}/resend-invite`, payload),
  )
}

export const getTeamPlan = async ({ teamId }: GetTeamPlanParams, { toast }: { toast?: boolean } = {}) => {
  return await apiErrorHandler(teamApi.get(`/${teamId}/plan`), { toast: toast ?? true })
}
